import _ from 'underscore';

// errors
export const errors = {
  NO_RECOMMENDATION: _TL_('There are no recommendations for this Final URL'),
  FinalURL: _TL_('Unable to generate recommendations for this Final URL'),
  DEFAULT: _TL_('Unable to generate recommendations'),
};

// convert placementTexts and placements to a map
export const placements = {
  SuperLeaderboard: {
    name: _TL_('970x90 Super leaderboard'),
    size: '970x90',
  },
  Leaderboard: {
    name: _TL_('728x90 Leaderboard'),
    size: '728x90',
  },
  FullBanner: {
    name: _TL_('468x60 Full banner'),
    size: '468x60',
  },
  SmallLeaderboard: {
    name: _TL_('320x50 Small leaderboard'),
    size: '320x50',
  },
  Banner: {
    name: _TL_('300x50 Banner'),
    size: '300x50',
  },
  LargeBanner: {
    name: _TL_('216x36 Large banner'),
    size: '216x36',
  },
  MediumBanner: {
    name: _TL_('168x28 Medium banner'),
    size: '168x28',
  },
  SmallBanner: {
    name: _TL_('120x20 Small banner'),
    size: '120x20',
  },
  HalfBanner: {
    name: _TL_('234x60 Half banner'),
    size: '234x60',
  },
  Billboard: {
    name: _TL_('970x250 Billboard'),
    size: '970x250',
  },
  LandscapeLargeBanner: {
    name: _TL_('320x100 Landscape large banner'),
    size: '320x100',
  },
  Landscape: {
    name: _TL_('480x320 Landscape'),
    size: '480x320',
  },
  LargeRectangle: {
    name: _TL_('336x280 Large rectangle'),
    size: '336x280',
  },
  MediumRectangle: {
    name: _TL_('300x250 Medium rectangle'),
    size: '300x250',
  },
  Rectangle: {
    name: _TL_('180x150 Rectangle'),
    size: '180x150',
  },
  Square: {
    name: _TL_('250x250 Square'),
    size: '250x250',
  },
  Portrait: {
    name: _TL_('320x480 Portrait'),
    size: '320x480',
  },
  HalfPage: {
    name: _TL_('300x600 Half page'),
    size: '300x600',
  },
  WideSkyscraper: {
    name: _TL_('160x600 Wide skyscraper'),
    size: '160x600',
  },
  Skyscraper: {
    name: _TL_('120x600 Skyscraper'),
    size: '120x600',
  },
};

const ratios = {
  [placements.SuperLeaderboard.size]: 'SuperLeaderboard',
  [placements.Leaderboard.size]: 'Leaderboard',
  [placements.FullBanner.size]: 'FullBanner',
  [placements.SmallLeaderboard.size]: 'SmallLeaderboard',
  [placements.Banner.size]: 'Banner',
  [placements.LargeBanner.size]: 'LargeBanner',
  [placements.MediumBanner.size]: 'MediumBanner',
  [placements.SmallBanner.size]: 'SmallBanner',
  [placements.HalfBanner.size]: 'HalfBanner',
  [placements.Billboard.size]: 'Billboard',
  [placements.LandscapeLargeBanner.size]: 'LandscapeLargeBanner',
  [placements.Landscape.size]: 'Landscape',
  [placements.LargeRectangle.size]: 'LargeRectangle',
  [placements.MediumRectangle.size]: 'MediumRectangle',
  [placements.Rectangle.size]: 'Rectangle',
  [placements.Square.size]: 'Square',
  [placements.Portrait.size]: 'Portrait',
  [placements.HalfPage.size]: 'HalfPage',
  [placements.WideSkyscraper.size]: 'WideSkyscraper',
  [placements.Skyscraper.size]: 'Skyscraper',
};

export const ratioGrouping = {
  XWide: [
    ratios[placements.SuperLeaderboard.size],
    ratios[placements.Leaderboard.size],
    ratios[placements.FullBanner.size],
    ratios[placements.SmallLeaderboard.size],
    ratios[placements.Banner.size],
    ratios[placements.LargeBanner.size],
    ratios[placements.MediumBanner.size],
    ratios[placements.SmallBanner.size],
  ],
  Landscape: [
    ratios[placements.HalfBanner.size],
    ratios[placements.Billboard.size],
    ratios[placements.LandscapeLargeBanner.size],
    ratios[placements.Landscape.size],
  ],
  Square: [
    ratios[placements.LargeRectangle.size],
    ratios[placements.MediumRectangle.size],
    ratios[placements.Rectangle.size],
    ratios[placements.Square.size],
  ],
  Vertical: [
    ratios[placements.Portrait.size],
    ratios[placements.HalfPage.size],
    ratios[placements.WideSkyscraper.size],
    ratios[placements.Skyscraper.size],
  ],
};

// MT has this unicode character : –
export const getPlacement = ad => ratios[ad.template.templateName.split('-')[0].trim()];

export const getPlacementFromTemplate = template => ratios[template.templateName.split('-')[0].trim()];

// add placement to each ad
export const addPlacementToAd = (ads) => {
  const adsWithPlacement = ads.map((ad) => {
    const MTPlacement = getPlacement(ad);

    return {
      ...ad,
      placement: MTPlacement,
    };
  });

  return adsWithPlacement;
};

// return a map grouped by image url
export const groupAdsByImages = (ads) => {
  const groupedAds = _.groupBy(ads, ad => ad.template.image.url);
  return groupedAds;
};

export const groupAdsByRatio = (groupedAds) => {
  const adsWithRatioGroups = {};

  const imageUrls = _.keys(groupedAds);

  // for each image url, group by placement ratio group
  _.each(imageUrls, (imageUrl) => {
    const ads = groupedAds[imageUrl];
    const groupedByPlacement = _.groupBy(ads, (ad) => {
      const { placement } = ad;
      const ratioGroup = _.findKey(ratioGrouping, ratiosKey => _.contains(ratiosKey, placement));
      return ratioGroup;
    });

    adsWithRatioGroups[imageUrl] = groupedByPlacement;
  });

  return adsWithRatioGroups;
};

const getRandomImageForEachRatioGroup = (adsWithRatioGroups) => {
  const randomImages = [];

  _.each(adsWithRatioGroups, (ads) => {
    const randomImage = _.mapObject(ads, (group) => {
      const randomAd = _.sample(group);

      const imageSuggestionCarouselObj = {
        thumbnailUrl: randomAd.url,
        fullUrl: randomAd.template.image.url,
        suggestionId: randomAd.recommendationId,
      };

      return imageSuggestionCarouselObj;
    });

    randomImages.push(..._.values(randomImage));
  });

  return randomImages;
};


export const processAndGroupAds = (ads) => {
  const adsWithPlacement = addPlacementToAd(ads);
  const groupedAds = groupAdsByImages(adsWithPlacement);
  const adsWithRatioGroups = groupAdsByRatio(groupedAds);

  return {
    imagesToSuggest: getRandomImageForEachRatioGroup(adsWithRatioGroups),
    groupedAds: adsWithRatioGroups,
  };
};


export const getItemsForListFromGroupedAds = (groupedAds) => {
  const items = [];

  _.each(groupedAds, (ratioGroups) => {
    _.each(ratioGroups, (ads) => {
      const sampleAd = _.sample(ads);

      const newItem = {
        id: sampleAd.recommendationId,
        previewSrc: sampleAd.url,
        previewType: sampleAd.placement,
        placements: ads.map(ad => ({
          id: ad.recommendationId,
          type: ad.placement,
        })),
      };

      items.push(newItem);
    });
  });

  return items;
};

export const getAdsInMatchingGroup = (groupedAds, id) => {
  const matchingGroup = _.find(groupedAds, ratioGroups => _.find(ratioGroups, ads => _.some(ads, ad => ad.recommendationId === id)));
  const matchingAds = _.find(matchingGroup, ads => _.some(ads, ad => ad.recommendationId === id));

  return matchingAds;
};

export const getODataConfig = (serverContext) => {
  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname.indexOf('ads.microsoft.com') === -1 &&
        hostname.indexOf('ads-int.microsoft.com') === -1;
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  const oDataConfig = {
    odataToken: serverContext.Token,
    oDataToken: serverContext.Token,
    odataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
    oDataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
  };

  return oDataConfig;
};
